<template lang="pug">
  v-menu(v-model="menuShowing" :close-on-content-click="false")
    template(v-slot:activator="{ on }")
      span(v-on="on") {{ will_come_to_course ? 'Yes' : 'No' }}
    div.select-menu
      div.select-menu-list
        v-list
          v-list-item(@click="$emit('update', true)") Yes
          v-list-item(@click="$emit('update', false)") No
</template>

<script>
  export default {
    props: {
      will_come_to_course: {
        type: Boolean,
        default: false,
      }
    },
    data: () => ({
      menuShowing: false,
    })
  }
</script>